import { exists } from '../generals'

import { type FilterText } from './types'

/**
 * フィルターテキストグループの配列を人間が読める1行のテキストに変換します。
 * 各フィルターは「{name} {subName}: {value, value, ...}」形式になり、
 * グループ内は ` AND `、グループ間は ` OR ` で連結されます。
 * 空配列の場合は空文字列を返します。
 *
 * @param filterTextGroups - フィルターテキストグループの配列。
 * @returns フィルター条件を表すテキスト（空配列の場合は空文字列）。
 */
export function formatFilterTextGroups(
  filterTextGroups: FilterText[][],
): string {
  return filterTextGroups
    .map((group) =>
      group
        .map(
          (ft) =>
            `${[ft.name, ft.subName].filter((s) => exists(s) && s !== '').join(' ')}: ${ft.values.join(', ')}`,
        )
        .join(' AND '),
    )
    .filter((groupText) => groupText !== '')
    .join(' OR ')
}
